import { useCartData } from "@/zustand/cartStore";
import React, { useState } from "react";
import { useProductData } from "@/zustand/productStore";

const PurchaseTypeSelector = ({ variant = "v2", showDescription = true, onChange }) => {
  const [selected, setSelected] = useState(true);
  const isSubscribe = useCartData((state) => state.isSubscribe);
  const setIsSubscribe = useCartData((state) => state.setIsSubscribe);
  const setProductsBySubscription = useProductData((state) => state.setProductsBySubscription);
  const base = window.subscription_template;
  const prefix = variant === "v3" ? "purchaseTypeSelectorV3" : "purchaseTypeSelector";

  const v3Vars =
    variant === "v3"
      ? {
          "--pts-active-bg": base?.pts_v3_active_bg || "#FDF7F2",
          "--pts-inactive-bg": base?.pts_v3_inactive_bg || "#ffffff",
          "--pts-active-text": base?.pts_v3_active_text || "#111111",
          "--pts-inactive-text": base?.pts_v3_inactive_text || "#111111",
        }
      : undefined;

  const handleSelect = (value) => {
    setSelected(value);
    setIsSubscribe(value);
    setProductsBySubscription(value);
    if (onChange) onChange(value);
  };

  if (variant === "v4") {
    const accentColor = base?.pts_v4_accent_color || "#828282";
    const v4Vars = {
      "--pts-v4-accent-color": accentColor,
      "--pts-v4-text-color": base?.pts_v4_text_color || "#6b5f5f",
    };
    const v4Label = base?.tr_pts_v4_label || base?.tr_subscribe_and_save;

    return (
      <div className="purchaseTypeSelectorV4__wrapper" style={v4Vars}>
        <input
          type="checkbox"
          id="subscribe-checkbox-v4"
          className="purchaseTypeSelectorV4__checkboxNative"
          checked={isSubscribe}
          onChange={(e) => handleSelect(e.target.checked)}
        />
        <span
          className="purchaseTypeSelectorV4__checkbox"
          onClick={() => handleSelect(!isSubscribe)}
          aria-hidden="true"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clipPath="url(#pts-v4-clip)">
              <rect width="16" height="16" rx="4" fill={isSubscribe ? accentColor : "none"} />
              {isSubscribe && (
                <path
                  d="M12.8985 3.34494C12.454 3.05628 11.8295 3.14549 11.5044 3.54035L6.45957 9.69L4.78045 7.79944C4.43828 7.41547 3.81109 7.35011 3.37947 7.65304C2.94653 7.95596 2.87367 8.51487 3.21454 8.89755L6.52295 12.6249L13.1166 4.584C13.4418 4.18781 13.3443 3.6336 12.8985 3.34494Z"
                  fill="white"
                />
              )}
            </g>
            <rect x="0.4" y="0.4" width="15.2" height="15.2" rx="3.6" stroke={accentColor} strokeWidth="0.8" />
            <defs>
              <clipPath id="pts-v4-clip">
                <rect width="16" height="16" rx="4" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        <label htmlFor="subscribe-checkbox-v4" className="purchaseTypeSelectorV4__label">
          {v4Label}
        </label>
      </div>
    );
  }

  return (
    <div className={`${prefix}__wrapper`} style={v3Vars}>
      <div className={`${prefix}__container`}>
        <div
          className={`${prefix}__option ${selected ? `${prefix}__selected` : ""}`}
          onClick={() => handleSelect(true)}
          role="button"
          tabIndex={0}
          aria-pressed={selected}
        >
          {base?.tr_subscribe_and_save}
        </div>
        <div
          className={`${prefix}__option ${!selected ? `${prefix}__selected` : ""}`}
          onClick={() => handleSelect(false)}
          role="button"
          tabIndex={0}
          aria-pressed={!selected}
        >
          {base?.tr_one_time_purchase}
        </div>
      </div>
      {showDescription && (
        <div className={`${prefix}__description`}>
          {isSubscribe ? base?.tr_subscription_description : base?.tr_onetime_description}
        </div>
      )}
    </div>
  );
};

export default PurchaseTypeSelector;
